module.exports = {
	"it": {
		"address": "<strong>SERGIO BIANCHI</strong><br />Studio di architettura<p>Via Rencati, 29 Cantù (CO)</p>",
		"tua_posizione": "La tua posizione"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/scripts/res/phrases.json
 ** module id = 43
 ** module chunks = 0
 **/